<template>
  <div class="basic-block block-fortune-input" :style="styles">
    <div class="content-wrap">
      <form :action="actionMod" :method="method" ref="form">
        <input type="hidden" name="_token" :value="token">
        <form-birthday
          v-model="birthday"
          name="birthday"
          label="生年月日"
          placeholderYear="1999"
          placeholderMonth="09"
          placeholderDay="09"
          :validation="{ rules: {birthRange: true, required: true} }"
        />
        <div class="formset">
          <form-input
            name="last_name"
            type="text"
            v-model="last_name"
            label="姓"
            placeholder="山田"
            :validation="{ rules: {max: 5, required: true} }"
            />
          <form-input
            name="first_name"
            type="text"
            v-model="first_name"
            label="名"
            placeholder="はな"
            :validation="{ rules: {max: 5, required: true} }"
            />
        </div>
        <lp-base-button label="無料で占う" design="fill" :color-scheme="colorScheme" class="submit-btn" :isDisabled="buttonIsDisabled" @clicked="clicked" />
      </form>
    </div>
  </div>
</template>

<script>
import LpBaseButton from '@/utvStore/components/recommend/lp/partials/LpBaseButton'
export default {
  name: 'BlockFortuneInput',
  components:{
    LpBaseButton
  },
  props: {
    targetInfo: {
      type: Object,
      default(){
        return {}
      }
    },
    colorScheme: {
      type: Object,
      default(){
        return {}
      }
    },
    action: {
      type: String,
      default: ''
    },
    method: {
      type: String,
      default: ''
    },
    token: {
      type: String,
      default: ''
    },
    lpId: Number,
    pageLabel: {
      type: String,
      default: '',
    },
  },
  data(){
    return {
      last_name: '',
      first_name: '',
      birthday: '',
      buttonIsDisabled: false
    }
  },
  computed:{
    actionMod(){
      return this.$handoverParams(this.action)
    },
    styles(){
      return {
        '--key-color': this.colorScheme.keyColor,
        '--second': this.colorScheme.second,
        '--grad-start': this.colorScheme.gradStart,
        '--grad-end': this.colorScheme.gradEnd,
      }
    },
    validateFlags () {
      return this.$validator.flags
    },
  },
  watch:{
    validateFlags: {
      handler(n,o) {
        this.buttonIsDisabled = Object.keys(n).some((key)=> n[key].invalid)
      },
      deep: true
    },
  },
  methods:{
    clicked(){
      window.gtag('event', 'click', {
        'event_category': `LP${this.lpId}${this.pageLabel}-free-shindan-button`,
      })
      this.$refs.form.submit()
    },
  }
}</script>

<style scoped lang="scss">
@import "../../../../../../../../sass/commons/commonVariables.scss";

$l_col_keycolor: var(--key-color);
$l_col_second: var(--second);
$l_col_grad_start: var(--grad-start);
$l_col_grad_end: var(--grad-end);

.block-fortune-input {
  background: #FFFBE3;
  padding: 0 20px 40px;
  .content-wrap{
    background: $col_white;
    border-radius: 10px;
    padding: 20px 20px 40px;
    .formset{
      display: flex;
      .form-input + .form-input{
        margin-left: 7px;
      }
    }
    .submit-btn{
      width: 270px;
      margin: 40px auto 0;
      @include mq('w580'){
        width: 72%
      }
    }
    .formGroup /deep/.calenderForm{
      border-radius: 5px !important;
      width: 171px !important;
      height: 40px !important;
      &.active{
        border-color: rgba(0, 0, 0, 0.15);
      }
      .formControl{
        min-height: 38px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/recommend/lp/counselor/kurenotori/blocks/BlockFortuneInput.vue